// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"25af19b8","102":"90b6f65a","432":"057b03ac","592":"a8633db0","816":"9b906e74","932":"0ba178bc"}[chunkId] + ".chunk.js";
};